import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function CalendarVerticalSkeleton() {
  return (
    <Stack spacing={1}>
      <Skeleton animation="wave" variant="text" height={60} />
      <Skeleton animation="wave" variant="rectangular" height={210} />
    </Stack>
  );
}
